import { IdentityDto } from './../../shared/identity.dto';

export class ProductSpecDto {
  identity = new IdentityDto();
  type: string;
  region: string;
  tags: string[] = [];
  brand: string;
  category: string; // enum from api
  productGroup: string;
  productLine: string | null;
  product: string | null;
  expression: string;
  country: string;

  constructor(d?: ProductSpecDto | null) {
    if (!d) {
      return;
    }

    this.identity = new IdentityDto(d.identity);
    this.type = d.type;
    this.region = d.region;
    this.tags = d.tags || [];
    this.category = d.category;
    this.productGroup = d.productGroup;
    this.country = d.country;
    this.productLine = d.productLine;
    this.product = d.product;
    this.brand = d.brand;
    this.expression = d.expression;
  }
}
